// AdminLayout.js
import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="admin-header-container">
          <div className="admin-brand">
            <div className="admin-logo">
              <span className="admin-logo-icon">⚙️</span>
              <h1>Admin Dashboard</h1>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className={`admin-mobile-toggle ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle admin menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation */}
          <nav className={`admin-nav ${isMobileMenuOpen ? 'open' : ''}`}>
            <NavLink 
              to="/admin" 
              end
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">📊</span>
              <span>Dashboard</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-events"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">📅</span>
              <span>Events</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-members"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">👥</span>
              <span>Members</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-volunteers"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🤝</span>
              <span>Volunteers</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-news"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">📰</span>
              <span>News</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-rewards"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🎁</span>
              <span>Rewards</span>
            </NavLink>
            <NavLink 
              to="/admin/manage-conferences"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🎓</span>
              <span>Conferences</span>
            </NavLink>
            <NavLink 
              to="/admin/gallery"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🖼️</span>
              <span>Gallery</span>
            </NavLink>
            <NavLink 
              to="/admin/fix-membership"
              className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🔧</span>
              <span>Fix IDs</span>
            </NavLink>
          </nav>

          {/* Actions */}
          <div className="admin-actions">
            <button 
              className="exit-admin-btn"
              onClick={() => navigate('/events')}
              title="Exit Admin Panel"
            >
              <span>Exit</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path fillRule="evenodd" d="M10 12.5a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v2a.5.5 0 001 0v-2A1.5 1.5 0 009.5 2h-8A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h8a1.5 1.5 0 001.5-1.5v-2a.5.5 0 00-1 0v2z"/>
                <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 000-.708l-3-3a.5.5 0 00-.708.708L14.293 7.5H5.5a.5.5 0 000 1h8.793l-2.147 2.146a.5.5 0 00.708.708l3-3z"/>
              </svg>
            </button>
          </div>
        </div>
      </header>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
